import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactPaginate from 'react-paginate'

const mapStateToProps = ({books}) => ({
  pageCount: books.paginate.pageCount
})

class PaginationContainer extends Component {
  render () {
    return (
      <div>
        {this.props.pageCount > 1 &&
        <nav className='pagination is-small is-centered'>
          <ReactPaginate
            previousLabel={'❮'}
            nextLabel={'❯'}
            previousClassName={'page-previous'}
            nextClassName={'page-next'}
            breakLabel={<a href=''>...</a>}
            breakClassName={'pagination-ellipsis'}
            pageCount={this.props.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            pageLinkClassName={'pagination-link'}
            onPageChange={this.props.handlePageClick}
            containerClassName={'pagination-list'}
            subContainerClassName={'pages'}
            activeClassName={'is-current'}
          />
        </nav>
        }
      </div>
    )
  }
}

export default connect(mapStateToProps, null)(PaginationContainer)



// WEBPACK FOOTER //
// ./src/containers/PaginationContainer/Books/index.js